















































import { Component, Vue } from "vue-property-decorator";

@Component
export default class Team extends Vue {
  data() {
    return {
      team: [
        {
          name: "Adam Billiard",
          position: "Chef Master",
          img: require("../assets/team/chefs_1.png")
        },
        {
          name: "Fred Macyard",
          position: "Chef Master",
          img: require("../assets/team/chefs_2.png")
        },
        {
          name: "Justin Stuard",
          position: "Chef Master",
          img: require("../assets/team/chefs_3.png")
        }
      ]
    };
  }
}
